import React from 'react'

import './FilterContainer.scss'

const FilterContainer = (props: {elements: React.ReactNode[]}) => {
  return (
    <div>
        <div className="filter">
            <div className="filter-header">
                <h2>Filters</h2>
            </div>
            <div className="filter-container">
                {props.elements.map(item => {
                    return (item)
                })}
            </div>
        </div>
    </div>
  )
}

export default FilterContainer